import {
  importProductsToFirebase,
  // getProductPageFromFirebase,
  getProductPageFromFirebaseNew,
  addProductToFirebase,
  updateProductTofirebase,
  deleteProductFromFirebase
} from '../utils/productService';

export const IMPORT_PRODUCTS = 'IMPORT_PRODUCTS';
export const IMPORT_PRODUCTS_SUCCESS = 'IMPORT_PRODUCTS_SUCCESS';
export const IMPORT_PRODUCTS_FAILURE = 'IMPORT_PRODUCTS_FAILURE';

export const GET_PRODUCTS_DATA = 'GET_PRODUCTS_DATA';
export const GET_PRODUCTS_DATA_SUCCESS = 'GET_PRODUCTS_DATA_SUCCESS';
export const GET_PRODUCTS_DATA_FAILURE = 'GET_PRODUCTS_DATA_FAILURE';

export const ADD_PRODUCT = 'ADD_PRODUCT';
export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS';
export const ADD_PRODUCT_FAILURE = 'ADD_PRODUCT_FAILURE';

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';

export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE = 'DELETE_PRODUCT_FAILURE';

export function importProducts(fileData){
  return async (dispatch) => {
    dispatch({ type: IMPORT_PRODUCTS });
    try {
      const token = localStorage.getItem('jwtToken');
      const { data } = await importProductsToFirebase({ token, data: fileData });
      return dispatch({ type: IMPORT_PRODUCTS_SUCCESS, payload: { log: data } });
    } catch ({ response: { data, status } }) {
      return dispatch({ type: IMPORT_PRODUCTS_FAILURE, payload: { error: { data, status } } });
    }
  }
}

export function getProductPage({ limit, reset = false }){
  return async (dispatch, getState) => {
    dispatch({ type: GET_PRODUCTS_DATA });
    try {
      const prevData = !reset ?  getState().product.products.data : {}
      const data = await getProductPageFromFirebaseNew( prevData, limit);
      return dispatch({ type: GET_PRODUCTS_DATA_SUCCESS, payload: { page: data, reset } });
    } catch (e) {
      return dispatch({ type: GET_PRODUCTS_DATA_FAILURE, payload: { error: e } });
    }
  }
}

export function addProduct({ data }){
  return async (dispatch) => {
    dispatch({ type: ADD_PRODUCT });
    try {
      const product = await addProductToFirebase({ data });
      return dispatch({ type: ADD_PRODUCT_SUCCESS, payload: { product } });
    } catch (e) {
      console.log(e);
      return dispatch({ type: ADD_PRODUCT_FAILURE, payload: { error: e } });
    }
  }
}

export function updateProduct({ key, data}){
  return async (dispatch) => {
    dispatch({ type: UPDATE_PRODUCT });
    try {
      const product = await updateProductTofirebase({ key, data });
      return dispatch({ type: UPDATE_PRODUCT_SUCCESS, payload: { product } });
    } catch (e) {
      return dispatch({ type: UPDATE_PRODUCT_FAILURE, payload: { error: e } });
    }
  }
}

export function deleteProduct({ key }){
  return async (dispatch) => {
    dispatch({ type: DELETE_PRODUCT });
    try {
      const product = await deleteProductFromFirebase({ key });
      return dispatch({ type: DELETE_PRODUCT_SUCCESS, payload: { product } });
    } catch (e) {
      return dispatch({ type: DELETE_PRODUCT_FAILURE, payload: { error: e } });
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/productActions.js